import { ActionType, TableColumn } from "../../../../Component/Model/Table/Table"
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { EEAverageAndMedianRemuneration } from "../../../../Component/Model/Dto/EmploymentEquity/AverageAndMedianRemuneration/AverageAndMedianRemuneration";
import { CurrencyFormatter } from "../../../../Helpers/CurrencyFormatter";

interface AvgAndMedianRemunerationRow {
    IdentificationNumber: string;
    EmployeeCode: string;
    FullName: string;
    Race: any;
    Gender: any;
    IsDisabled: string;
    PositionName: string;
    OccupationalLevel: any;
    AnnualSalary: number;
}

interface TopAndBottomEarnersTable {
    columns: Array<TableColumn>;
    rows: Array<AvgAndMedianRemunerationRow>;
}

export function TopAndBottomEarnersTableMapper(dataObject: EEAverageAndMedianRemuneration.TopAndBottomEarner[]): TopAndBottomEarnersTable {

    const columns = [
        { Header: 'Identification Number', accessor: 'IdentificationNumber', Cell: ({ value }: any) => <DefaultCell value={value} /> , disableSortBy: true},
        { Header: 'Employee Code', accessor: 'EmployeeCode', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Full Name', accessor: 'FullName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Race', accessor: 'Race', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Gender', accessor: 'Gender', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Is Disabled', accessor: 'IsDisabled', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Position Name', accessor: 'PositionName', Cell: ({ value }: any) => <DefaultCell value={value} /> ,disableSortBy: true },
        { Header: 'Occupational Level', accessor: 'OccupationalLevel', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Annual Salary', accessor: 'AnnualSalary', Cell: ({ value }: any) => <DefaultCell value={CurrencyFormatter(value ?? "")} /> },
        //{ Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (dataObject.length > 0) {
        const rows = dataObject.map((item: EEAverageAndMedianRemuneration.TopAndBottomEarner) => ({
            IdentificationNumber: item.identificationNumber,
            EmployeeCode: item.employeeCode,
            FullName: item.fullName,
            Race: item.race,
            Gender: item.gender,
            IsDisabled: item.isDisabled ? 'Yes' : 'No',
            PositionName: item.positionName,
            OccupationalLevel: item.occupationalLevel,
            AnnualSalary: item.annualSalary
        }));

        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}


